export class Settings {
    rotateTop;
    rotateBoard;
}